// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/7.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato:300,400,700,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-user-select: none;
          user-select: none;
}

.HomeAtletas {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  min-height: 100vh;
  background-size: 75vh;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Poppins', sans-serif;
}

.logo {
  height: 20vh;
  width: 20vh;
  margin-top: 2vh;
}

.elements {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.backTitulo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 50vh;
  margin: 0 auto;
}

.title {
  margin-bottom: 4vh;
  font-size: 2rem;
}

.cajaTitulo {
  width: 100%;
  max-width: 50vh;
  width: 80%;
  margin-right: auto;
  margin-left: auto;
  margin-top: 3vh;
}
.cajaInfo{
  margin-top: 4vh;
  width: 80%;
  margin-right: auto;
  margin-left: auto;
  font-family: 'Poppins', sans-serif;
}

.button {
  color: #fff;
  margin: 1rem;
  padding: 0.5em 1rem;
  font-size: 1.2rem;
  cursor: pointer;
  background: #449dd5;
  border: 0.05rem solid #449dd5;
}

.text-button{
  font-weight: 1000;
  margin-bottom: 0;
  font-style: oblique;
}

.button:hover {
  background-color: transparent;
  transition: all 0.5s ease;
}

.botones {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}


@media screen and (max-width: 389px) {
  .HomeAtletas {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 100%;
    background-size: 75vh;
    background-repeat: repeat;
    background-position: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Lato', sans-serif;
  }
}`, "",{"version":3,"sources":["webpack://./src/static/css/HomeAtletas.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yDAAqC;EACrC,iBAAiB;EACjB,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;;AAGA;EACE;IACE,yDAAqC;IACrC,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,+BAA+B;EACjC;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Lato:300,400,700,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Mulish&display=swap');\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  user-select: none;\n}\n\n.HomeAtletas {\n  background-image: url('../img/7.png');\n  min-height: 100vh;\n  background-size: 75vh;\n  background-repeat: no-repeat;\n  background-position: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-family: 'Poppins', sans-serif;\n}\n\n.logo {\n  height: 20vh;\n  width: 20vh;\n  margin-top: 2vh;\n}\n\n.elements {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.backTitulo {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  max-width: 50vh;\n  margin: 0 auto;\n}\n\n.title {\n  margin-bottom: 4vh;\n  font-size: 2rem;\n}\n\n.cajaTitulo {\n  width: 100%;\n  max-width: 50vh;\n  width: 80%;\n  margin-right: auto;\n  margin-left: auto;\n  margin-top: 3vh;\n}\n.cajaInfo{\n  margin-top: 4vh;\n  width: 80%;\n  margin-right: auto;\n  margin-left: auto;\n  font-family: 'Poppins', sans-serif;\n}\n\n.button {\n  color: #fff;\n  margin: 1rem;\n  padding: 0.5em 1rem;\n  font-size: 1.2rem;\n  cursor: pointer;\n  background: #449dd5;\n  border: 0.05rem solid #449dd5;\n}\n\n.text-button{\n  font-weight: 1000;\n  margin-bottom: 0;\n  font-style: oblique;\n}\n\n.button:hover {\n  background-color: transparent;\n  transition: all 0.5s ease;\n}\n\n.botones {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n\n@media screen and (max-width: 389px) {\n  .HomeAtletas {\n    background-image: url('../img/7.png');\n    height: 100%;\n    background-size: 75vh;\n    background-repeat: repeat;\n    background-position: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-family: 'Lato', sans-serif;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
